export default __webpack_public_path__ + "static/media/swl_price.b0aa0bd5.png";